import { useEffect, useState } from 'react';

export default function ChallanPreview({ bytes }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!bytes) return;
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const u = URL.createObjectURL(blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [bytes]);

  if (!url) {
    return (
      <div className="flex items-center justify-center h-full opacity-60">
        Generating preview…
      </div>
    );
  }

  return (
    <iframe
      title="Challan preview"
      src={url}
      className="w-full h-full border-0"
    />
  );
}
